module.exports = __webpack_public_path__ + "img/bg-system2.18ddbdb0.png";